import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-info-circle-icon',
  templateUrl: './code-info-circle.component.html'
})
export class CodeInfoCircleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
